import qs from "qs";
import authAxios, { authHeader } from "../../data";
import { IImpoundsPost } from "../../../types/Impounds";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/Impounds", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/Impounds/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: { contactId: string }) => {
  const response = await authAxios.get("/api/Impounds/Count", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchByNumber = async (request: { contractId: string }) => {
  const response = await authAxios.get("/api/Impounds/ByNumber", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const deleteOne = async (id: string) => {
  const response = await authAxios.delete("/api/Impounds/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (request: IImpoundsPost) => {
  const response = await authAxios.post("/api/Impounds", request, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (request: IImpoundsPost, id: string) => {
  const response = await authAxios.put("/api/Impounds/" + id, request, {
    headers: authHeader(),
  });

  return response.data;
};

const getExcel = async () => {
  const response = await authAxios.get("/api/Export/Impounds", {
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const ImpoundsService = {
  fetchAll,
  fetch,
  fetchCount,
  deleteOne,
  create,
  edit,
  fetchByNumber,
  getExcel,
};

export default ImpoundsService;
